import { FIELD_NAME } from '../constants/form-constants';
import { formService } from '../form-service';
import { Oferta, OfertaDatoEconomico } from '../types/oferta-types';
import { formatSlugToTitle } from '../utils/string-utils';

class OfertaEntityClass {
	private static instance: OfertaEntityClass;

	private constructor() {}

	static getInstance(): OfertaEntityClass {
		if (!OfertaEntityClass.instance) {
			OfertaEntityClass.instance = new OfertaEntityClass();
		}
		return OfertaEntityClass.instance;
	}

	private get oferta(): Oferta | undefined {
		return formService.getFieldValue(FIELD_NAME.OFERTA) as Oferta;
	}

	get isEmpty(): boolean {
		return !this.oferta;
	}

	get descripcion(): string {
		return this.oferta?.carline?.salesgroup?.model?.descripcion || this.oferta?.descripcion || '';
	}

	get promociones(): string | undefined {
		if (!this.oferta?.promociones || this.oferta?.promociones.length == 0) return undefined;
		return this.oferta.promociones.map((promo) => promo.name).join(', ');
	}

	get tipoFinanciacion(): string | undefined {
		if (!this.oferta?.datosEconomicos || this.oferta?.datosEconomicos.length == 0) return undefined;

		const tipoFinanciacion = this.oferta.datosEconomicos
			.filter((d) => d.periodicidad !== 'pago-unico')
			.reduce((prev, curr) => (curr.prioridad > prev.prioridad ? curr : prev), {
				prioridad: -Infinity,
			} as (typeof this.oferta.datosEconomicos)[0])?.tipoFinanciacion;

		return formatSlugToTitle(tipoFinanciacion);
	}

	get detalles(): string {
		if (!this.oferta?.datosEconomicos?.length) return '';

		return this.oferta.datosEconomicos
			.map((dato: OfertaDatoEconomico) => {
				const tipo = dato.periodicidad === 'pago-unico' ? 'Precio' : 'Cuota';
				const precio = dato.precio != null ? `${dato.precio} Eur` : '-';
				const periodicidad = dato.periodicidad && dato.periodicidad != 'pago-unico' ? dato.periodicidad : '-';
				const plazos = dato.plazos != null && dato.plazos > 1 ? dato.plazos : '-';
				const entrada = dato.pagoEntrada != null ? `${dato.pagoEntrada} Eur` : '-';
				const final = dato.pagoFinal != null ? `${dato.pagoFinal} Eur` : '-';
				const tin = dato.tin != null ? `TIN: ${dato.tin}%` : '';
				const tae = dato.tae != null ? `TAE: ${dato.tae}%` : '';

				return (
					`${tipo}: ${precio} / \r\n` +
					`Periodicidad Cuota: ${periodicidad} / \r\n` +
					`Num Cuotas: ${plazos} / \r\n` +
					`Entrada: ${entrada} / \r\n` +
					`Cuota final: ${final}${tin || tae ? '/' : ''}\r\n` +
					`${tin}${tin && tae ? '/ \r\n' : ''}${tae}`
				);
			})
			.join('\r\n\r\n');
	}
}

export const ofertaEntity = OfertaEntityClass.getInstance();
